@use './variables' as *;
@use '../../styles/abstracts/' as *;

@import '~slim-select/src/slim-select/slimselect';

// Provide slim select styling variables
:host {
  width: $dropdown-multi-width;
  min-width: $dropdown-multi-min-width;
  max-width: $dropdown-multi-max-width;

  // Colors
  --ss-primary-color: #{$dropdown-multi-chip-background-color};
  --ss-bg-color: #{$dropdown-multi-background-color};
  --ss-font-color: #{$dropdown-multi-color};
  --ss-font-placeholder-color: #{$dropdown-multi-placeholder-color};
  --ss-disabled-color: #{$dropdown-multi-disabled-color};
  --ss-border-color: #{$dropdown-multi-border-color};

  // Heights
  --ss-content-height: #{$dropdown-multi-content-height};

  // Spacing
  --ss-spacing-l: #{$dropdown-multi-spacing-l};
  --ss-spacing-m: #{$dropdown-multi-spacing-m};
  --ss-spacing-s: #{$dropdown-multi-spacing-s};

  // Misc
  --ss-animation-timing: #{$dropdown-multi-animation-timing};
  --ss-border-radius: #{$dropdown-multi-border-radius};
}

@mixin status($selectColor, $selectBorderColor, $statusText) {
  .ss-main {
    color: $selectColor;
    border-color: $selectBorderColor;
  }

  .status-text {
    color: $statusText;
  }
}

.air-dropdown-multi-wrapper {
  &.error {
    @include status(
      $dropdown-multi-error-color,
      $dropdown-multi-error-border-color,
      $dropdown-multi-error-message-color
    );
  }

  &.success {
    @include status(
      $dropdown-multi-success-color,
      $dropdown-multi-success-border-color,
      $dropdown-multi-success-message-color
    );
  }

  &:not(.with-status):hover {
    .ss-main:not([disabled]):not([readonly]) {
      color: $dropdown-multi-hover-color;
      border-color: $dropdown-multi-hover-border-color;
      background-color: $dropdown-multi-hover-background-color;
    }
  }

  .status-text {
    display: block;
    font-family: $dropdown-multi-font-family;
    font-size: $dropdown-multi-font-size;
    font-weight: $dropdown-multi-font-weight;
    margin-top: $dropdown-multi-status-text-margin-top;
    margin-right: $dropdown-multi-status-text-margin-right;
    margin-bottom: $dropdown-multi-status-text-margin-bottom;
    margin-left: $dropdown-multi-status-text-margin-left;
  }

  .ss-main {
    font-family: $dropdown-multi-font-family;
    font-size: $dropdown-multi-font-size;
    font-weight: $dropdown-multi-font-weight;
    line-height: $dropdown-multi-line-height;
    color: $dropdown-multi-color;
    border: $dropdown-multi-border-width $dropdown-multi-border-style $dropdown-multi-border-color;
    border-radius: $dropdown-multi-border-radius;

    &:focus {
      outline: none;
      box-shadow: 0 0 0 $dropdown-multi-focus-outline-width $dropdown-multi-focus-outline-color;
    }

    &[disabled] {
      background-color: $dropdown-multi-disabled-background-color;
      border-color: $dropdown-multi-disabled-border-color;
      color: $dropdown-multi-disabled-color;
    }

    &[readonly] {
      background-color: $dropdown-multi-readonly-background-color;
      border-color: $dropdown-multi-readonly-border-color;
      color: $dropdown-multi-readonly-color;
    }

    .ss-values {
      .ss-placeholder {
        padding: $dropdown-multi-chip-padding-vertical 0;
      }

      .ss-value {
        .ss-value-text {
          font-family: $dropdown-multi-font-family;
          font-size: $dropdown-multi-font-size;
          font-weight: $dropdown-multi-font-weight;

          padding: $dropdown-multi-chip-padding-vertical $dropdown-multi-spacing-m;
        }

        .ss-value-delete {
          padding: $dropdown-multi-chip-padding-vertical $dropdown-multi-spacing-m;
        }
      }
    }

    .ss-arrow {
      height: $dropdown-multi-icon-height;
      width: $dropdown-multi-icon-width;
    }
  }

  .ss-content {
    border: $dropdown-multi-content-border-width $dropdown-multi-content-border-style
      $dropdown-multi-content-border-color;

    .ss-option {
      font-family: $dropdown-multi-font-family;
      font-size: $dropdown-multi-font-size;
      font-weight: $dropdown-multi-font-weight;

      padding: $dropdown-multi-option-padding-vertical $dropdown-multi-option-padding-horizontal;
    }
  }
}
